<template>
    
    <div class="list-item list-item--article"
        :class="css"
        ref="article">
        <div class="cell cell--cb">
            <input type="checkbox" :disabled="!data.articleVariation.isPurchasable" :value="data" v-model="model"/>
        </div>
        <div class="cell cell--ref">{{ data.articleVariation.article.reference }}</div>
        <div class="cell cell--main">            
            <ArticleTitle :article="data.articleVariation.article" />
        </div>
        <div class="cell cell--secondary">{{ data.articleVariation.uvCodeLibelle }}<span v-if="data.articleVariation.uvCoef > 1" style="white-space: pre">&nbsp;x{{ data.articleVariation.uvCoef }}</span></div>
        <div class="cell cell--price">
            <Price :amount="price" currency="EUR" />
        </div>
        <div class="cell cell--stat" :class="{ 'zero': data.periods[0].count === 0 }">
            <div class="cell__label">{{ formatPeriod(data.periods[0]) }}</div>
            <div class="cell__value">{{ data.periods[0].count }}</div>
        </div>
        <div class="cell cell--stat" :class="{ 'zero': data.periods[1].count === 0 }">
            <div class="cell__label">{{ formatPeriod(data.periods[1]) }}</div>
            <div class="cell__value">{{ data.periods[1].count }}</div>
        </div>
        <div class="cell cell--stat" :class="{ 'zero': data.periods[2].count === 0 }">
            <div class="cell__label">{{ formatPeriod(data.periods[2]) }}</div>
            <div class="cell__value">{{ data.periods[2].count }}</div>
        </div>
        <div class="cell cell--actions">
            <AddToCart
                :article="data.articleVariation.article"
                :variation="data.articleVariation"
                v-if="data.articleVariation.article.isAvailable"/>
        </div>
    </div>

</template>

<script>

import AddToCart from '@/components/addToCart/AddToCart.vue'
import ArticleTitle from '@/components/articleTitle/ArticleTitle.vue'
import Price from '@/components/price/Price.vue'

import  { useFormatPeriod } from '@/helpers/period'

export default {

    props: {

        data: {
            type: Object,
            required: true
        },

        periodicity: {
            type: String,
            required: false
        },

        value: Array
    },
    
    computed: {

        css: function () {
            return ''
        },

        price: function() {

            if ( this.data.articleVariation && this.data.articleVariation.price ) {
                return ( this.data.articleVariation.price + this.data.articleVariation.tgap )
            }

            return null
        },

        model: {

            get() {
                return this.value;
            },

            set(value) {
                this.$emit("input", value);
            }
        }
    },

    methods: {

        formatPeriod(period) {
            return useFormatPeriod(period, this.periodicity)
        }
    },  

    components: {
        AddToCart,
        ArticleTitle,
        Price,
    }
}
</script>

<style scoped>

@media screen and (max-width: 799px) { 

    .list-item.list-item--article .cell.cell--price {
        flex: auto;
        margin-bottom: 1rem;
        width: 100%;
    }

    .list-item.list-item--article .cell.cell--stat {
        flex: 1;
    }

    .list-item.list-item--article .cell.cell--actions {
        flex: 2;
    }
}

</style>